<div class="global-toast-container">
  <div
    *ngFor="let toast of toasts$ | async"
    class="global-toast"
    [ngClass]="'toast-' + toast.type"
    role="alert"
  >
    <!-- Left Icon -->
    <div class="toast-icon">
      <span *ngIf="toast.type === 'success'">✓</span>
      <span *ngIf="toast.type === 'error'">✕</span>
      <span *ngIf="toast.type === 'warning'">⚠</span>
      <span *ngIf="toast.type === 'info'">ℹ</span>
    </div>

    <!-- Message -->
    <div class="toast-content">
      <div class="toast-title">
        {{ toast.type | titlecase }}
      </div>

      <div class="toast-message">
        {{ toast.message }}
      </div>
    </div>

    <!-- Close Button -->
    <button
      type="button"
      class="toast-close"
      (click)="remove(toast.id)"
      aria-label="Close notification"
    >
      ×
    </button>
  </div>
</div>
